const HeaderConfig = {
    headers: {
    },
  };
  
  export default HeaderConfig;